<template>
	<ui-box :form="refs.retailForm" :eager="!!product.id" new-forms>

		<form-title title="What's the Retail Price?"></form-title>

		<form-divider inner/>

		<v-row>
			<v-col cols="12" sm="7" md="5" lg="4">
				<v-switch
						v-model="pricingStrategy"
						class="mt-3"
						dense
						hide-details="auto"
						inset
						label="Use admission pricing tiers?"
						true-value="tiers"
						false-value="pricing"
				></v-switch>
			</v-col>
			<v-col
					cols="12"
					:sm="origin === 'partner-portal' ? 6 : 5"
					:md="origin === 'partner-portal' ? 6 : 5"
					:lg="origin === 'partner-portal' ? 5 : 4"
			>
				<v-row v-if="!usePricingTiers">
					<v-col>
						<v-text-field
							v-model.number="admission.retail_price"
							v-two-decimals
							:class="'mt-4 mt-sm-0 rounded-lg' + (origin === 'partner-portal' ? '' : ' required')"
							hide-spin-buttons
							label="General Admission"
							outlined
							persistent-hint
							:prefix="pricePrefix"
							:rules="origin !== 'partner-portal' && rules.retail_price || []"
							type="number"
							@wheel.native.prevent
						></v-text-field>
					</v-col>
					<v-col v-if="origin === 'partner-portal'">
						<v-text-field
							v-model.number="admission.net_rate"
							v-two-decimals
							class="mt-4 mt-sm-0 rounded-lg"
							hide-spin-buttons
							label="General Admission Remittance"
							outlined
							persistent-hint
							:prefix="pricePrefix"
							type="number"
							@wheel.native.prevent
						></v-text-field>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<!-- Price -->
		<v-row v-if="usePricingTiers">
			<v-col cols="12" md="6">
				<v-row>
					<v-col :cols="colConfig.cols" :sm="colConfig.sm" :md="colConfig.md">
						<span>Retail Price</span>
					</v-col>
					<v-col v-if="origin === 'partner-portal'" cols="4" sm="4" md="4">
						<span>Remittance Rate</span>
					</v-col>
					<v-col :cols="subtitleColConfig.cols" :sm="subtitleColConfig.sm"
								 :md="subtitleColConfig.md">
						<span>Subtitle</span>
					</v-col>
				</v-row>
				<v-row v-for="attribute in attributes" :key="attribute.label">
					<v-col :cols="colConfig.cols" :sm="colConfig.sm" :md="colConfig.md">
						<v-text-field
							v-model.number="attribute.retail_price"
							v-two-decimals
							class="rounded-lg"
							hide-spin-buttons
							:label="attribute.label"
							outlined
							persistent-hint
							:prefix="pricePrefix"
							type="number"
							@wheel.native.prevent
						></v-text-field>
					</v-col>
					<v-col v-if="origin === 'partner-portal'" cols="4" sm="4" md="4">
						<v-text-field
							v-model.number="attribute.net_rate"
							v-two-decimals
							class="rounded-lg"
							hide-spin-buttons
							:label="attribute.label"
							outlined
							persistent-hint
							:prefix="pricePrefix"
							type="number"
							@wheel.native.prevent
						></v-text-field>
					</v-col>
					<v-col
							:cols="subtitleColConfig.cols"
							:sm="subtitleColConfig.sm"
							:md="subtitleColConfig.md"
					>
						<v-text-field
								v-model="attribute.sub_title"
								class="rounded-lg"
								:hint="attribute.hint"
								:label="`${attribute.label} Subtitle`"
								outlined
								persistent-hint
						></v-text-field>
					</v-col>
				</v-row>
			</v-col>

		</v-row>
		<!-- End: Price -->
	</ui-box>
</template>

<script>
import FormDivider from "../../../../UI/Form/FormDivider.vue";

export default {
	name: 'PricingForm',
	components: { FormDivider },
	props: {
		admission: {
			type: Object,
			required: true
		},
		formIsValid: {
			type: Object,
			required: true
		},
		origin: {
			type: String,
			default: ''
		},
		partner: {
			type: Object,
			required: true
		},
		product: {
			type: Object,
			required: true
		},
		refs: {
			type: Object,
			required: true
		},
		rules: {
			type: Object,
			required: true
		},
	},

	data() {
		return {
			attributes: [],
			pricingStrategy: 'pricing',
		};
	},
	computed: {
		colConfig() {
			return {
				cols: this.origin === 'partner-portal' ? 4 : 4,
				sm: this.origin === 'partner-portal' ? 4 : 4,
				md: this.origin === 'partner-portal' ? 4 : 5
			};
		},
    pricePrefix() {
      return (this.partner?.currencyPrefix || '$') + ' ';
    },
		subtitleColConfig() {
			return {
				cols: this.origin === 'partner-portal' ? 4 : 8,
				sm: this.origin === 'partner-portal' ? 4 : 8,
				md: this.origin === 'partner-portal' ? 4 : 7
			};
		},
		usePricingTiers() {
			return this.pricingStrategy === 'tiers';
		},

	},
	mounted() {
		this.attributes = this.admission.attributes;
		this.pricingStrategy = this.admission?.attributes?.filter(x => x.retail_price)?.length > 0
				? 'tiers'
				: 'pricing';
		this.updateAdmission();
	},
	methods: {
		updateAdmission() {
			if(this.pricingStrategy === 'pricing') {
				this.admission.attributes = [];
			}
			else {
				this.admission.attributes = Object.values(this.attributes).filter(attribute => attribute.retail_price !== null);
				if(this.admission.attributes) {
					let sortOrder = 0;
					this.admission.attributes.forEach(attribute => {
						attribute.sort_order = sortOrder++;
					})
				}
				this.admission.retail_price = 0.0;
				this.admission.net_rate = 0.0;
			}
		},
	},
	watch: {
		pricingStrategy: {
			handler() {
				this.updateAdmission();
			},
			deep: true
		},
		attributes: {
			handler() {
				this.updateAdmission();
			},
			deep: true
		},
	}
}
</script>

<style scoped>
/* Add your styles here */
</style>